const _ = require('lodash');
const toastr = require('toastr/toastr');
const ImpressService = require('../../services/ImpressService');

module.exports = {
    data: {
        servicesChanged: false
    },
    props: ['verticals', 'selectedVerticals', 'index', 'user', 'onSelectedVerticalsChanged', 'postSelected'],
    created() {
        ImpressService.onLeave("choose", () => {
            if (this.servicesChanged) {
                this.saveVerticals(this.selectedVerticals);
            }
        });
    },
    methods: {
        isSelected(vertical, value) {
            return _.includes(this.selectedVerticals[vertical], value);
        },
        selectVertical(vertical, value) {
            const add = !this.isSelected(vertical, value);
            const current = this.selectedVerticals[vertical];
            const updated = add ? _.concat(current, [value]) : _.without(current, value);

            this.updateVerticals(vertical, updated);
            this.servicesChanged = true;
        },
        selectVerticalArray(vertical, all, selected) {
            var current = this.selectedVerticals[vertical];
            var updated = _.difference(current, all).concat(selected);
            this.updateVerticals(vertical, updated);
        },
        updateVerticals(vertical, updated) {
            this.$set(this.selectedVerticals, vertical, updated.filter(x => x));
        },
        saveVerticals(selectedVerticals) {
            this.onSelectedVerticalsChanged(selectedVerticals)
                .then(() => {
                    toastr.success('Selected services saved');
                })
                .catch((err) => {
                    console.error('Error updating verticals', err);
                })
                .then(() => {
                    this.servicesChanged = false;
                    this.postSelected();
                    this.reloadAllFrames();
                });
        },
        reloadAllFrames() {
            $('iframe[name^=demo]').each(function (i, iframe) {
                $(iframe).attr('src', $(iframe).attr('src'));
            });
        },
        parse: _.kebabCase,
        clear() {
            _.keys(this.selectedVerticals).map((vertical) => {
                this.updateVerticals(vertical, []);
            });
        }
    },
    template: require('./services.html')
};



//////////////////
// WEBPACK FOOTER
// ./src/js/components/services/services.js
// module id = 96
// module chunks = 0